export default __webpack_public_path__ + "static/media/goshen5.9daedf64.jpg";